<template>
  <section class="app-recommendation-section">
    <h2 class="section-title">{{ title }}</h2>
    <div class="app-content">
      <div class="app-image" v-if="showImage">
        <!-- <img src="../assets/home/home-1.webp" :alt="imageAlt" /> -->
        <img :src="imageSrc" :alt="imageAlt" />
      </div>
      <div class="app-text">
        <p v-html="description"></p>
        <button class="app-download-btn" @click="handleDownload">{{ buttonText }}</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppRecommendationSection',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: 'Free Download InstaSave'
    },
    imageSrc: {
      type: String,
      default: '../assets/home/home-1.webp'
    },
    imageAlt: {
      type: String,
      default: 'InstaSave App'
    },
    showImage: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleDownload() {
      this.$emit('go-to-download');
    }
  }
}
</script>

<style scoped>
.section-title {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
}
.app-recommendation-section {
  padding: 20px 20px;
  background: white;
}

.app-content {
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
}

.app-image {
  width: 230px;
  height: 230px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.app-text p {
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 24px;
  color: #666;
}

.app-download-btn {
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 50px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
  box-shadow: 0 4px 15px rgba(255,107,107,0.3);
}

.app-download-btn:hover {
  background: linear-gradient(135deg, #ff5252, #d63031);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255,107,107,0.4);
}

/* Link styles within description */
.app-text p a {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
  border-bottom: 2px solid transparent;
  transition: all 0.3s ease;
}

.app-text p a:hover {
  color: #5a67d8;
  border-bottom-color: #5a67d8;
}

/* Responsive Design */
@media (max-width: 768px) {
  .app-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .app-image {
    width: 200px;
    height: 200px;
  }
}
</style>
